module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-plan-iStock-1352225167.69fe1c15.jpg";